import * as React from 'react';
import { ActionPlanTopic } from '../../../amorg-common';
import { SurveyTopicInfoPanel } from './SurveyTopicInfoPanel';

type ActionPlanTopicContextPanelProps = {
    topic: ActionPlanTopic,
};
export function ActionPlanTopicContextPanel (props: ActionPlanTopicContextPanelProps): JSX.Element
{
    return (
        <>
            {props.topic && props.topic.type === 'WPA' &&
                <SurveyTopicInfoPanel surveyTopic={props.topic.surveyTopic} />
            }
        </>
    );
}